import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'

import { accessRole } from '../../../../helpers/access_role'

import CreateBloc from './Blocs/CreateBloc'
import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar'
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import CustomSelect from '../../GlobalComponents/CustomSelect'

// const peg_uuid = JSON.parse(localStorage.getItem('userdata'))?.employee_uuid ?? "";
// const peg_nip = JSON.parse(localStorage.getItem('userdata'))?.employee_nip ?? "";

var reformatOptionRegion = function(regions) {
  return regions.map(function(region) {
    var newObj = {};
    newObj["label"] = region.region_name;
    newObj["value"] = region.region_uuid;

    return newObj;
  });
};

var reformatOptions = function(raw, label, value) {
    return raw.map(function(data) {
      var newObj = {};
      newObj["label"] = data[label];
      newObj["value"] = data[value];
  
      return newObj;
    });
  };

class IndexView extends Component {

    createBloc = new CreateBloc();

    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_uuid = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_uuid : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_uuid : "")
    peg_nip = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_nip : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_nip : "")

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            optionGender : [
              { label: "Dinas Luar", value: "Dinas Luar" },
              { label: "Di Kantor", value: "Di Kantor" }
            ],
            optionNational : [
                { label: "Dalam Negeri", value: "Dalam Negeri" },
                { label: "Luar Negeri", value: "Luar Negeri" }
              ],
            selectedGender: "",
            birthOptionCountry: [],
            birthSelectedCountry: "9da7d06b-b10c-4e28-a543-3442cc0f0182", // Sekertaris Utama
            birthOptionProvince : [],
            birthSelectedProvince: "",
            birthOptionCity : [],
            birthSelectedCity: ""
        }
    }

    // Select Area

    handleBirthSelectCountry = (birthSelectedCountry) => {
        let selected = birthSelectedCountry.value;
        this.getBirthProvinceByCountry(selected);
    }

    getBirthProvinceByCountry(selected_uuid){
        this.createBloc.regionProvinceChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)

                        this.setState({
                            birthOptionProvince: reformatOptions(
                                response.result, 
                                'region_name',
                                'region_uuid'
                            )
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.createBloc.fetchRegionProvince({
          //is_local: 1,
          parent_uuid : selected_uuid,
          type : 2  
        })
    }


    handleBirthSelectProvince = (birthSelectedProvince) => {
      this.setState({
        birthSelectedProvince: birthSelectedProvince.value
      });

      // get data city where province selected
      this.createBloc.regionCityChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.COMPLETED:
                  if(result.data.status) {
                      let response = result.data.response
                      //console.log(response)
                      
                      this.setState({
                          birthOptionCity: reformatOptionRegion(response.result)
                      })
                  }
                  break
              case apiResponse.ERROR:
                  
                  break
              default:
                  break
          }
      })
      this.createBloc.fetchRegionCity({
        is_local: 1,
        type : 3,
        parent_uuid : birthSelectedProvince.value
      })
    }

    handleBirthSelectCity = (birthSelectedCity) => {
      this.setState({
        birthSelectedCity: birthSelectedCity.value
      });
    }

    handleSelectGender = (selectedGender) => {
      this.setState({
        selectedGender: selectedGender.value
      });
    }

    // End Select Area

    submitData = async () => {
        const formData = generateFormData(this.state.dataForm, ['file','file_pernyataan_pelantikan','file_pakta','file_jabatan','file_tugas'])
        await this.createBloc.fetchCreate(formData)
        console.log(formData)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              employee_uuid : this.peg_uuid,
              ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        // get data birth country
        this.createBloc.regionCountryChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)

                        this.setState({
                            birthOptionCountry: reformatOptions(
                                response.result, 
                                'signatories_official_position',
                                'signatories_official_uuid'
                            )
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.createBloc.fetchRegionCountry({
          type : 1  
        })

        this.getBirthProvinceByCountry(this.state.birthSelectedCountry);

        // get data province
        this.createBloc.regionProvinceChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        
                        this.setState({
                            birthOptionProvince: reformatOptionRegion(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.createBloc.fetchRegionProvince({
          is_local: 1,
          type : 2  
        })
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <PegawaiSideBar active="riwayatsumpah"/>

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <CardTitle>Tambah Data Dokumen Pelantikan</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        {/* <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nomor Riwayat <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="swear_history_no"
                                                    placeholder="Nomor Sumpah..."
                                                    type="text"
                                                    errorMessage="Masukkan Nomor Sumpah"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="swear_history_no"
                                                />
                                                <AvField
                                                    name="peg_uuid"
                                                    placeholder="Nomor Sumpah..."
                                                    type="hidden"
                                                    errorMessage="Masukkan Nomor Sumpah"
                                                    className="form-control"
                                                    id="peg_uuid"
                                                    value={peg_uuid}
                                                />

                                                </Col>
                                            </Row> */}
                                            <AvField
                                                name="employee_nip"
                                                placeholder="Nomor Sumpah..."
                                                type="hidden"
                                                errorMessage="Masukkan Nomor Sumpah"
                                                className="form-control"
                                                id="employee_nip"
                                                value={this.peg_nip}
                                            />

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Berita Acara Pelantikan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="swear_history_date"
                                                    placeholder="Tanggal Dokumen Pelantikan..."
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal Dokumen Pelantikan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="swear_history_date"
                                                />
                                            </Col>
                                        </Row>

                                        {/* <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Keterangan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="swear_history_description"
                                                    placeholder="Keterangan..."
                                                    type="text"
                                                    errorMessage="Masukkan Keterangan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="swear_history_description"
                                                />
                                            </Col>
                                        </Row> */}
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                                Dokumen Upload Berita Acara Pelantikan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="6">
                                                <FileInput 
                                                    name="file"
                                                    isMultiple
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        {/* B */}
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nomor Surat Pernyataan Pelantikan 
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="swear_history_inaguration_number"
                                                    placeholder="Nomor Surat Pernyataan Pelantikan..."
                                                    type="text"
                                                    errorMessage="Masukkan Nomor Surat Pernyataan Pelantikan"
                                                    className="form-control"
                                                    // validate={{ required: { value: true } }}
                                                    id="swear_history_inaguration_number"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Surat Pernyataan Pelantikan 
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="swear_history_inaguration_date"
                                                    placeholder="Tanggal Surat Pernyataan Pelantikan..."
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal Surat Pernyataan Pelantikan"
                                                    className="form-control"
                                                    // validate={{ required: { value: true } }}
                                                    id="swear_history_inaguration_date"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                                Dokumen Upload Surat Pernyataan Pelantikan 
                                            </label>
                                            <Col md="6">
                                                <FileInput 
                                                    name="file_pernyataan_pelantikan"
                                                    isMultiple
                                                />
                                            </Col>
                                        </Row>
                                        
                                        {/* C */}
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Pakta Integritas 
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="swear_history_pact_date"
                                                    placeholder="Tanggal Pakta Integritas..."
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal Pakta Integritas"
                                                    className="form-control"
                                                    // validate={{ required: { value: true } }}
                                                    id="swear_history_pact_date"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                                Dokumen Upload Pakta Integritas
                                            </label>
                                            <Col md="6">
                                                <FileInput 
                                                    name="file_pakta"
                                                    isMultiple
                                                />
                                            </Col>
                                        </Row>

                                        {/* D */}
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nomor Surat Pernyataan Menduduki Jabatan 
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="swear_history_duty_number"
                                                    placeholder="Nomor Surat Pernyataan Menduduki Jabatan..."
                                                    type="text"
                                                    errorMessage="Masukkan Nomor Surat Pernyataan Menduduki Jabatan"
                                                    className="form-control"
                                                    // validate={{ required: { value: true } }}
                                                    id="swear_history_duty_number"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Surat Pernyataan Menduduki Jabatan 
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="swear_history_duty_date"
                                                    placeholder="Tanggal Surat Pernyataan Menduduki Jabatan..."
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal Surat Pernyataan Menduduki Jabatan"
                                                    className="form-control"
                                                    // validate={{ required: { value: true } }}
                                                    id="swear_history_duty_date"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                                Dokumen Upload Surat Pernyataan Menduduki Jabatan 
                                            </label>
                                            <Col md="6">
                                                <FileInput 
                                                    name="file_jabatan"
                                                    isMultiple
                                                />
                                            </Col>
                                        </Row>
                                        {/* E */}
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nomor Surat Pernyataan Melaksanakan Tugas
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="swear_history_execute_number"
                                                    placeholder="Nomor Surat Pernyataan Melaksanakan Tugas..."
                                                    type="text"
                                                    errorMessage="Masukkan Nomor Surat Pernyataan Melaksanakan Tugas"
                                                    className="form-control"
                                                    // validate={{ required: { value: true } }}
                                                    id="swear_history_execute_number"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Surat Pernyataan Melaksanakan Tugas 
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="swear_history_execute_date"
                                                    placeholder="Tanggal Surat Pernyataan Melaksanakan Tugas..."
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal Surat Pernyataan Melaksanakan Tugas"
                                                    className="form-control"
                                                    // validate={{ required: { value: true } }}
                                                    id="swear_history_execute_date"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                                Dokumen Upload Surat Pernyataan Melaksanakan Tugas 
                                            </label>
                                            <Col md="6">
                                                <FileInput 
                                                    name="file_tugas"
                                                    isMultiple
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <div className="form-check form-switch mb-3">
                                                <AvCheckboxGroup name="checkboxExample" required errorMessage="Agreement harus di centang">
                                                    <AvCheckbox label="Saya yakin dan bertanggung jawab atas data ini" value="1" />
                                                </AvCheckboxGroup>
                                                
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/kepegawaian/home.html?riwayatsumpah">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/home.html?riwayatsumpah'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView